<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500px"
    @keydown.esc="dialog = false"
  >
    <card>
      <card-title large closeable @click:close="dialog = false">
        Изменение порядка и публикации
      </card-title>
      <card-content class="pt-0">
        <validation-observer ref="validator" tag="div">
          <v-row dense class="mb-4">
            <v-col>
              <validation-provider
                v-slot="{ errors }"
                rules="required|is_integer"
                mode="eager"
                name="Порядок"
              >
                <v-text-field
                  :id="`form-text-seq`"
                  v-model="seq"
                  label="Порядок"
                  outlined
                  dense
                  :error-messages="errors"
                  hide-details
                >
                  <template v-slot:append-outer>
                    <v-tooltip v-if="errors.length > 0" top color="error">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="error" dark v-bind="attrs" v-on="on">
                          mdi-alert-circle
                        </v-icon>
                      </template>
                      <span>{{ errors.join("\n") }}</span>
                    </v-tooltip>
                    <div v-else class="mr-6"></div>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row v-for="(val, lang) in published" :key="lang" dense>
            <v-col class="d-flex">
              <div
                class="lang-icon ml-2"
                :style="
                  `background-image: url(${baseUrl}img/lang-${lang}.svg);`
                "
              />
              <v-checkbox
                :id="`form-checkbox-published-${lang}`"
                v-model="published[lang]"
                :true-value="1"
                :false-value="0"
                class="pt-0 mt-0 mb-4 ml-4"
                label="Опубликовано"
                hide-details
              />
            </v-col>
          </v-row>
        </validation-observer>
      </card-content>
      <card-actions>
        <v-spacer />
        <v-btn
          id="form-btn-cancel"
          color="primary"
          depressed
          outlined
          @click="dialog = false"
        >
          Закрыть
        </v-btn>
        <v-btn id="form-btn-save" color="primary" depressed @click="saveSeq()">
          Сохранить
        </v-btn>
      </card-actions>
    </card>
  </v-dialog>
</template>
<script>
import Repository from "@/api/node";
import NotificationMixin from "@/mixins/NotificationMixin";

export default {
  mixins: [NotificationMixin],
  model: {
    prop: "open",
    event: "change"
  },
  props: {
    open: Boolean,
    meta: {
      type: Object,
      required: true
    },
    nodeId: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      seq: "",
      published: {}
    };
  },
  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    },
    baseUrl() {
      return process.env.BASE_URL;
    }
  },
  watch: {
    open(newVal) {
      if (newVal && this.nodeId) {
        this.loadSeq();
      } else if (!newVal) {
        this.resetForm();
        this.$emit("close");
      }
    }
  },
  methods: {
    async saveSeq() {
      try {
        if (!(await this.$refs.validator.validate())) return;
        const { seq, nodeId, published } = this;

        this.loading = true;

        const { data } = await Repository.setSeqPub(nodeId, seq, published);

        this.$emit("apply");
        this.sendAlert(data.alert);

        this.dialog = false;
      } catch (error) {
        return true;
      } finally {
        this.loading = false;
      }
    },
    async loadSeq() {
      try {
        const { nodeId } = this;
        this.loading = true;
        const { data } = await Repository.getSeqPub(nodeId);
        this.seq = data.seq;
        this.published = data.published;
      } catch (error) {
        return true;
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.seq = "";
      this.published = {};
      if (this.$refs.validator) this.$refs.validator.reset();
    }
  }
};
</script>
<style lang="scss" scoped>
.lang-icon {
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  background-size: 22px;
  border-radius: 24px;
  background-position: center;
  border: 2px solid #d8e0e6;
}
</style>
